import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export default class ProductHeroCarousel extends HTMLElement {
  constructor() {
    super();

    // bindings

    // privates
    this._node = this;
    this._swiper_el = this._node.querySelector(".hero-carousel");
    this._pagination = this._node.querySelector(".pagination");
    this._slide = this._node.querySelectorAll(".swiper-slide");

    // events
    this._swiper = new Swiper(this._swiper_el, {
      a11y: true,
      speed: 333,
      loop: false,
      draggable: true,
      autoHeight: false,
      slidesPerView: 'auto',
      watchOverflow: true,
      pagination: {
        el: this._pagination,
        clickable: true
      },
      keyboard: {
        enabled: false
      }
    });

    this._swiper.on('slideChangeTransitionEnd', (data) => {
      let video = this._slide[data.activeIndex].querySelector('video');
      if (video) {
        video.pause();
        video.currentTime = 0;
        video.play();
      }
    });
  }

  /**
   * Handle unmount.
   */
  disconnectedCallback() {
  }
}
